export const TRIAL_DEFAULT_DAYS = 14;
export const TRIAL_MAX_TEMPLATES = 3;
export const TRIAL_MAX_MANAGERS = 3;

const TRIAL_FEATURES_TEXT =
  "3 templates, up to 3 managers, and real rounds you can run today. No setup fees, no IT project, no commitment.";

export function computeDaysRemainingFromEndDate(endDate) {
  if (!endDate) return null;
  const end = new Date(endDate);
  if (Number.isNaN(end.getTime())) return null;
  const ms = end.getTime() - Date.now();
  if (ms <= 0) return 0;
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}

export function getTrialVersionLimitations(daysRemaining) {
  const prefix = formatTrialDaysPrefix(daysRemaining);
  return `${prefix}: ${TRIAL_FEATURES_TEXT}`;
}

function formatTrialDaysPrefix(daysRemaining) {
  if (daysRemaining == null || Number.isNaN(Number(daysRemaining))) {
    return `Your ${TRIAL_DEFAULT_DAYS}-day trial`;
  }

  const days = Math.max(0, Math.ceil(Number(daysRemaining)));

  if (days <= 0) {
    return "Your trial ends today";
  }
  if (days === 1) {
    return "Your 1-day trial (1 day left)";
  }
  return `Your ${days}-day trial (${days} days left)`;
}

export function isTrialUser(adminData) {
  const d = adminData && adminData.data;
  if (!d) return false;
  if (d.isPaid === true) return false;
  return d.isTrial === true;
}

export function isTrialPlanName(planName) {
  const p = String(planName || "")
    .trim()
    .toLowerCase();
  return p === "trial" || p === "free";
}

export function isManagerRoleId(roleId) {
  return Number(roleId) === 5;
}

export function isManagerRoleName(roleName) {
  return String(roleName || "").trim().toLowerCase() === "manager";
}

export function isManagerRole(roleId, roles = []) {
  if (roleId == null || roleId === "") return false;
  if (isManagerRoleId(roleId)) return true;
  if (!Array.isArray(roles) || roles.length === 0) return false;
  const match = roles.find((role) => String(role.roleId) === String(roleId));
  return isManagerRoleName(match?.roleName);
}

export function isTrialEmployeeLimitApiMessage(message) {
  return /\b(only|up to|allowed|maximum|max)\b.*\b(employee|manager)s?\b/i.test(
    String(message || "")
  );
}

export function trialAdminUsersLockedMessage() {
  return "Admin Users is not available during the free trial. Upgrade to manage admin accounts.";
}

export function trialTemplateEditLockedMessage() {
  return "Editing templates is not available during the free trial.";
}

export function trialTemplateDeleteLockedMessage() {
  return "Deleting templates is not available during the free trial.";
}

export function trialTemplateLimitMessage() {
  return `Free trial includes up to ${TRIAL_MAX_TEMPLATES} templates. Upgrade to add more.`;
}

export function trialTemplateLockedMessage() {
  return "This template is not available during the free trial. Only active templates can be viewed.";
}

export function trialTempTaskLockedMessage() {
  return "Only tasks included in your free-trial templates are available. Other tasks are locked during the trial.";
}

export function isTrialTemplateAccessible(template) {
  return !!(template && template.isActive);
}

export function trialManagerLimitMessage() {
  return `Free trial includes up to ${TRIAL_MAX_MANAGERS} managers. Upgrade to add more.`;
}

export function trialEmployeeUploadLockedMessage() {
  return "Bulk employee upload is not available during the free trial.";
}

export function showTrialRestrictionToast(vm, message) {
  if (!vm || !vm.$swal) return;
  vm.$swal.fire({
    icon: "info",
    title: message,
    confirmButtonColor: "#26527A",
    confirmButtonText: "OK",
  });
}
